if (!customElements.get('main-favorites')) {
    /**
     * Represents the MainFavorites custom element.
     * @class
     * @extends HTMLElement
     */
    class MainFavorites extends HTMLElement {
        constructor() {
            super();
            this.productGrid = this.querySelector('ul.favorites-grid');
            this.spinner = this.querySelector('.loading-spinner');
            this.emptyStateEl = document.getElementById('empty');

            if (this.favorites.length > 0) {
                this.fetchProducts();
            } else {
                this.emptyStateEl.classList.remove('hidden');
                this.emptyStateEl.closest('main-favorites').classList.remove('favorites-has-content');
                this.spinner.classList.add('hidden');
            }
        }

        get favorites() {
            const valueCookie = getCookie('favorites');
            let favorites = [];
            if (valueCookie) {
                const cookieParsed = JSON.parse(valueCookie);
                if (Array.isArray(cookieParsed)) {
                    favorites = cookieParsed;
                }
            }
            return favorites;
        }

        /**
         * Fetches the HTML content of a product using its handle.
         *
         * @param {string} handle - The handle of the product.
         * @returns {Promise<HTMLLIElement>} - A promise that resolves to an HTML list item element containing the fetched product HTML.
         */
        async fetchProductHTML(handle) {
            const productHTML = await fetch(`/products/${handle}?section_id=main-favorites`).then((res) => res.text());

            const parser = new DOMParser();
            const doc = parser.parseFromString(productHTML, 'text/html');
            const favoritesResult = doc.querySelector('.favorites-results product-card');
            favoritesResult.querySelectorAll('img[data-src]').forEach((img) => setImageSources(img));
            const li = document.createElement('li');
            li.appendChild(favoritesResult);
            return li;
        }

        /**
         * Fetches products and appends them to the product grid.
         * @returns {Promise<Array<HTMLElement>>} An array of HTML elements representing the fetched products.
         */
        async fetchProducts() {
            const batchedFavorites = batchArray(this.favorites, 4);
            await Promise.all(
                batchedFavorites.map(async (favoritesArray) => {
                    const productsHTML = await Promise.all(
                        favoritesArray.map(async (handle) => this.fetchProductHTML(handle))
                    );
                    productsHTML.forEach((el) => this.productGrid.appendChild(el));
                    return productsHTML;
                })
            );
            this.spinner.classList.add('hidden');
        }
    }

    customElements.define('main-favorites', MainFavorites);
}

window.addEventListener("load", (event) => {
    const itemsFavorite = document.querySelectorAll('#product-grid add-favorite');
    itemsFavorite.forEach(itemFavorite => {
        function removeItems() {
            itemFavorite.closest('li').remove();
            let countItems = document.querySelector('#product-grid').childNodes.length;
            if(countItems == 0) {
                let prElm = document.querySelector('#product-grid');
                let emptyMess = document.querySelector('.favorites-empty');
                prElm.closest('main-favorites').classList.remove('favorites-has-content');
                emptyMess.classList.remove('hidden');
            }
        }
        itemFavorite.addEventListener('click', removeItems);
    });
});